var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "globalHeaderContainer",
    staticClass: "gh-headerContainer"
  }, [_c('div', {
    staticClass: "gh-globalHeader"
  }, [_c('div', {
    staticClass: "gh-logoContainer"
  }, [_c('a', {
    attrs: {
      "href": "https://multimediafluids.uam.elogim.com/academic"
    }
  }, [_c('cup-logo', {
    staticClass: "gh-logo gh-logo-desktop",
    attrs: {
      "aria-label": "Homepage Cambridge University Press"
    }
  })], 1)]), _c('global-nav', {
    attrs: {
      "show-discovery-tool": _vm.showDiscoveryTool,
      "environment": _vm.environment
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };